"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplifyReduxFormInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var SimplifyReduxFormInput = function (WrappedInput) {
    var SimplifiedInput = function (_a) {
        var onChangeProp = _a.onChange, directOnChange = _a.directOnChange, value = _a.value, name = _a.name, error = _a.error, props = __rest(_a, ["onChange", "directOnChange", "value", "name", "error"]);
        var _b = __read(react_1.default.useState({ active: false, touched: false }), 2), meta = _b[0], setState = _b[1];
        var setActive = function (active) { return setState(({ active: active, touched: meta.touched || active })); };
        var onFocus = function () { return setActive(true); };
        var onBlur = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setActive(false);
            if (props.onBlur)
                return props.onBlur.apply(props, __spreadArray([], __read(args), false));
            return undefined;
        };
        var onChange = directOnChange
            || (function (e) {
                var _a;
                return (onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(e && typeof e === 'object' && 'target' in e ? (_a = e.target) === null || _a === void 0 ? void 0 : _a.value : e));
            });
        return ((0, jsx_runtime_1.jsx)(WrappedInput, __assign({ input: {
                value: value,
                name: name,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
            }, meta: __assign(__assign({}, meta), { error: error }) }, props)));
    };
    return SimplifiedInput;
};
exports.SimplifyReduxFormInput = SimplifyReduxFormInput;
exports.default = exports.SimplifyReduxFormInput;
